export const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export const emptyHighlight = { title: "", description: "", imageUrl: "" };
export const emptySlide = { url: "", alt: "", title: "", subtitle: "", position: "center" };
export const emptyBrand = { name: "", logoUrl: "", alt: "", query: "" };
export const emptyFont = { family: "", url: "", weight: "400", style: "normal", format: "woff2" };

export const emptySettings = {
  publicStatus: "draft",
  revision: 1,
  business: {
    name: "",
    shortDescription: "",
    whatsapp: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    province: "",
    country: "Argentina",
    schedule: "",
    mapEmbedUrl: "",
    socials: {
      instagram: "",
      facebook: "",
      tiktok: "",
      linkedin: "",
      youtube: "",
      website: "",
    },
  },
  navigation: {
    style: "style-1",
    homeUrl: "/",
    productsUrl: "/productos",
    contactUrl: "/contact",
    loginUrl: "/login",
    showProductsLink: true,
    showContactLink: true,
    showCart: true,
    showCustomerAccess: true,
    showSocialLinks: true,
    homeLabel: "Inicio",
    productsLabel: "Productos",
    allProductsLabel: "Ver todos",
    contactLabel: "Contacto",
    loginLabel: "Iniciar sesión",
    accountLabel: "Mi cuenta",
    logoutLabel: "Cerrar sesión",
    cartLabel: "Ver carrito",
    cartTooltip: "Carrito",
    socialTitle: "Redes sociales",
    loadingCategoriesText: "Cargando categorías…",
    emptyCategoriesText: "No hay categorías todavía.",
    categoriesErrorText: "No se pudieron cargar las categorías.",
    menuAriaLabel: "Abrir menú",
    closeMenuAriaLabel: "Cerrar menú",
    cartAriaLabel: "Abrir carrito",
  },
  hero: {
    eyebrow: "",
    title: "",
    subtitle: "",
    primaryCtaLabel: "Consultar",
    primaryCtaUrl: "/contact",
    primaryCtaRequiresProducts: false,
    secondaryCtaLabel: "Ver productos",
    secondaryCtaUrl: "/productos",
    secondaryCtaRequiresProducts: true,
    imageUrl: "",
    imagePosition: "center",
    overlay: "linear-gradient(to bottom, rgba(0,0,0,.14), rgba(8,8,20,.72))",
    rotatingPhrases: [],
    slides: [],
  },
  catalog: {
    brands: {
      eyebrow: "",
      title: "Marcas",
      subtitle: "Elegí una marca y explorá el catálogo disponible.",
      loadingText: "Cargando marcas…",
      emptyText: "Todavía no hay marcas para mostrar.",
      errorText: "No se pudieron cargar las marcas.",
      ctaLabel: "Ver productos",
      items: [],
    },
    spotlight: {
      enabled: false,
      eyebrow: "",
      title: "",
      description: "",
      logoUrl: "",
      logoAlt: "",
      backgroundImageUrl: "",
      ctaLabel: "",
      ctaUrl: "",
      ctaRequiresProducts: true,
      primaryColor: "#F35A3A",
      secondaryColor: "#19242F",
    },
    featured: {
      eyebrow: "",
      title: "Productos destacados",
      subtitle: "Conocé las últimas novedades del catálogo.",
      loadingText: "Cargando productos…",
      emptyText: "Todavía no hay productos para mostrar.",
      errorText: "No se pudieron cargar los productos.",
      ctaLabel: "Ver detalle",
    },
    categories: {
      eyebrow: "",
      title: "Explorá por categorías",
      subtitle: "",
      loadingText: "Cargando categorías…",
      emptyText: "Todavía no hay categorías para mostrar.",
      errorText: "No se pudieron cargar las categorías.",
      ctaLabel: "Ver productos",
      productSingular: "producto",
      productPlural: "productos",
    },
  },
  about: {
    eyebrow: "",
    title: "",
    description: "",
    imageUrl: "",
    imageAlt: "",
    ctaLabel: "",
    ctaUrl: "",
    ctaRequiresProducts: false,
  },
  highlightsIntro: {
    eyebrow: "",
    title: "Por qué elegirnos",
    subtitle: "",
  },
  highlights: [],
  contact: {
    title: "Contacto",
    subtitle: "",
    whatsappMessage: "Hola, quiero hacer una consulta.",
    backgroundImageUrl: "",
    detailsCtaLabel: "Ver contacto",
    detailsCtaUrl: "/contact",
    whatsappCtaLabel: "Escribir por WhatsApp",
    floatingWhatsappAriaLabel: "Contactar por WhatsApp",
    mapTitle: "Ubicación",
  },
  footer: {
    style: "style-1",
    showLogo: true,
    tagline: "",
    copyright: "{businessName}. Todos los derechos reservados.",
    navigationTitle: "Navegación",
    contactTitle: "Contacto",
    homeLabel: "Inicio",
    productsLabel: "Productos",
    contactLabel: "Contacto",
  },
  messages: {
    maintenanceTitle: "Estamos actualizando el sitio",
    maintenanceDescription: "{businessName} se encuentra temporalmente en mantenimiento.",
    unavailableTitle: "Sitio no disponible",
    unavailableDescription: "La presencia pública de este proyecto todavía no está habilitada.",
    catalogDisabledTitle: "Catálogo no disponible",
    catalogDisabledDescription: "El catálogo no está habilitado para este sitio.",
    ordersDisabledTitle: "Pedidos no disponibles",
    ordersDisabledDescription: "Podés consultar el catálogo y comunicarte directamente con el comercio.",
    ecommerceDisabledTitle: "Pago online no disponible",
    ecommerceDisabledDescription: "El pedido puede coordinarse directamente con el comercio.",
  },
  theme: {
    template: "catalog-basic",
    primaryColor: "#F35A3A",
    secondaryColor: "#19242F",
    surfaceColor: "#FFFFFF",
    backgroundColor: "#EEF0F5",
    textColor: "#1A1A2E",
    mutedTextColor: "#5B5D73",
    dividerColor: "rgba(26,26,46,.09)",
    logoUrl: "",
    compactLogoUrl: "",
    faviconUrl: "",
    fontFamily: "Asap",
    headingFontFamily: "Exo 2",
    bodyFontFamily: "Asap",
    googleFontsUrl: "",
    fonts: [],
    borderRadius: 10,
    mode: "light",
  },
  seo: {
    title: "",
    description: "",
    imageUrl: "",
  },
  sections: {
    showNavbar: true,
    showHero: true,
    showSpotlight: true,
    showBrands: true,
    showProducts: true,
    showFeatured: true,
    showCategories: true,
    showAbout: true,
    showHighlights: true,
    showContact: true,
    showFooter: true,
    showFloatingWhatsapp: true,
  },
};

export function mergeSettings(data) {
  const source = data || {};
  return {
    ...emptySettings,
    ...source,
    business: {
      ...emptySettings.business,
      ...(source.business || {}),
      socials: {
        ...emptySettings.business.socials,
        ...(source.business?.socials || {}),
      },
    },
    navigation: { ...emptySettings.navigation, ...(source.navigation || {}) },
    hero: {
      ...emptySettings.hero,
      ...(source.hero || {}),
      slides: Array.isArray(source.hero?.slides)
        ? source.hero.slides.map((slide) => ({ ...emptySlide, ...slide }))
        : [],
    },
    catalog: {
      ...emptySettings.catalog,
      ...(source.catalog || {}),
      brands: {
        ...emptySettings.catalog.brands,
        ...(source.catalog?.brands || {}),
        items: Array.isArray(source.catalog?.brands?.items)
          ? source.catalog.brands.items.map((item) => ({ ...emptyBrand, ...item }))
          : [],
      },
      spotlight: { ...emptySettings.catalog.spotlight, ...(source.catalog?.spotlight || {}) },
      featured: { ...emptySettings.catalog.featured, ...(source.catalog?.featured || {}) },
      categories: { ...emptySettings.catalog.categories, ...(source.catalog?.categories || {}) },
    },
    about: { ...emptySettings.about, ...(source.about || {}) },
    highlightsIntro: { ...emptySettings.highlightsIntro, ...(source.highlightsIntro || {}) },
    highlights: Array.isArray(source.highlights)
      ? source.highlights.map((item) => ({ ...emptyHighlight, ...item }))
      : [],
    contact: { ...emptySettings.contact, ...(source.contact || {}) },
    footer: { ...emptySettings.footer, ...(source.footer || {}) },
    messages: { ...emptySettings.messages, ...(source.messages || {}) },
    theme: {
      ...emptySettings.theme,
      ...(source.theme || {}),
      fonts: Array.isArray(source.theme?.fonts)
        ? source.theme.fonts.map((font) => ({ ...emptyFont, ...font }))
        : [],
    },
    seo: { ...emptySettings.seo, ...(source.seo || {}) },
    sections: { ...emptySettings.sections, ...(source.sections || {}) },
  };
}

export const editorSections = [
  { id: "navbar", label: "Navbar" },
  { id: "hero", label: "Hero" },
  { id: "spotlight", label: "Spotlight" },
  { id: "featured", label: "Destacados" },
  { id: "brands", label: "Marcas" },
  { id: "categories", label: "Categorías" },
  { id: "about", label: "Nosotros" },
  { id: "highlights", label: "Diferenciales" },
  { id: "contact", label: "Contacto" },
  { id: "footer", label: "Footer" },
  { id: "floatingWhatsapp", label: "WhatsApp flotante" },
  { id: "identity", label: "Identidad" },
  { id: "seo", label: "SEO y estados" },
];

export function displayText(value, fallback) {
  return String(value || "").trim() || fallback;
}

export function resolveBusinessToken(value, businessName) {
  return displayText(value, "").replaceAll("{businessName}", displayText(businessName, "Tu negocio"));
}
